(function() {
    'use strict';

    angular
        .module('TR')
        .factory('ecommerceService', ecommerceService);

    function ecommerceService(
        tripService,
        basketStore,
        attractionService,
        carHireService,
        $q,
        loaderService,
        $window,
        cookieService,
        $http) {
        const productType = {
            0: function getHotelInfo(transactionId, hotel) {
                if (hotel && hotel.Details) {
                    const hotelDetails = hotel.Details;

                    const hotelInfo = {
                        id: transactionId,
                        category: 'Accommodation',
                        name: hotelDetails.EstablishmentId,
                        price: basketStore.sumCosts(hotel.CostBreakdown),
                        quantity: 1,
                        sku: hotelDetails.ProvinceTitle
                    };

                    return $q.when([hotelInfo]);
                }

                return $q.when(null);
            },
            1: function getFlightInfo(transactionId, flight) {
                if (flight && flight.Details) {
                    const flightLeg = flight.Details.Itinerary.Legs[0];
                    const segmentInfo = flightLeg.Segments[0];

                    const flightInfo = {
                        id: transactionId,
                        category: 'Flight',
                        name: segmentInfo.CarrierName,
                        price: basketStore.sumCosts(flight.CostBreakdown),
                        quantity: 1,
                        sku: segmentInfo.DestinationAirportTitle
                    };
                    return $q.when([flightInfo]);
                }

                return $q.when(null);
            },
            2: function getTransferInfo(transactionId, transfer) {
                if (transfer && transfer.Details) {
                    const transferDetails = transfer.Details;

                    const transferInfo = {
                        id: transactionId,
                        category: 'Transfer',
                        name: transferDetails.TransferId.SupplierId,
                        price: basketStore.sumCosts(transfer.CostBreakdown),
                        quantity: 1,
                        sku: (transferDetails.Itinerary.OutboundLeg || transferDetails.Itinerary.InboundLeg).DeparturePoint
                    };

                    return $q.when([transferInfo]);
                }
                return $q.when(null);
            },
            3: function getParkingInfo(transactionId, parking) {
                if (parking && parking.Details) {
                    const parkingDetails = parking.Details;

                    const parkingInfo = {
                        id: transactionId,
                        category: 'Parking',
                        name: parkingDetails.AirportParkingQuoteId.SupplierId,
                        price: basketStore.sumCosts(parking.CostBreakdown),
                        quantity: 1,
                        sku: parkingDetails.AirportParkingQuoteId.CarParkCode
                    };

                    return $q.when([parkingInfo]);
                }
                return $q.when(null);
            },
            4: function getAttractionInfo(transactionId, attraction, flight) {
                if (attraction && attraction.Details && flight && flight.Details) {
                    const flightLeg = flight.Details.Itinerary.Legs[0];
                    const segmentInfo = flightLeg.Segments[0];
                    const sku = segmentInfo.DestinationAirportTitle;

                    const attractionDetails = attraction.Details;
                    const attractionInfo = {
                        id: transactionId,
                        category: 'Attractions',
                        price: basketStore.sumCosts(attraction.CostBreakdown),
                        quantity: 1
                    };

                    return attractionService.getAttractionQuotesFromSession(attraction.AvailabilitySearchId).then(attractions => {
                        const attractionBreakdown = _.map(attractionDetails.AttractionIds, (element, index) => {
                            const cost = attraction.CostBreakdown[index];
                            const price = basketStore.sumCosts([cost]);

                            const res = _.findIndex(attractions, a => a.AttractionId === element);

                            if (res >= 0) {
                                const attr = attractions[res];
                                return _.assignIn({}, attractionInfo, { name: attr.ShortTitle, sku, price });
                            }
                            return $q.when(null);
                        });

                        return $q.when(attractionBreakdown);
                    });
                }
                return $q.when(null);
            },
            5: function getCarHireInfo(transactionId, carHire) {
                if (carHire && carHire.Details) {
                    const carHireDetails = carHire.Details;
                    let carHireInfo = {
                        id: transactionId,
                        category: 'Car Hire',
                        price: basketStore.sumCosts(carHire.CostBreakdown),
                        quantity: 1,
                        sku: carHireDetails.HireDetails.PickUpPoint
                    };
                    return carHireService.getCarQuotesFromSession(carHire.AvailabilitySearchId).then(carhire => {
                        const hireProvider = _.filter(carhire, elem => elem.CarHireId.CarHireCode === carHireDetails.CarHireId.CarHireCode);

                        carHireInfo = _.assignIn({}, carHireInfo, {
                            name: hireProvider[0].SupplierName
                        });

                        return $q.when(carHireInfo);
                    });
                }
                return $q.when(null);
            },
            6: function getMarhabaInfo(transactionId, marhaba) {
                if (marhaba && marhaba.CostBreakdown) {
                    const marhabaInfo = {
                        id: transactionId,
                        category: 'Marhaba',
                        price: basketStore.sumCosts(marhaba.CostBreakdown),
                        quantity: 1,
                        name: 'Marhaba',
                        sku: 'Marhaba'
                    };

                    return $q.when(marhabaInfo);
                }
                return $q.when(null);
            },
            7: function getInsuranceInfo(transactionId, insurance) {
                if (insurance && insurance.CostBreakdown) {
                    const insuranceInfo = {
                        id: transactionId,
                        category: 'Insurance',
                        price: basketStore.sumCosts(insurance.CostBreakdown),
                        quantity: 1,
                        name: 'Insurance',
                        sku: 'Insurance'
                    };

                    return $q.when(insuranceInfo);
                }
                return $q.when(null);
            }
        };


        let basketData = {};

        function pushBasket(tripId, baskets, totalCost, bookingRefs) {

            if (TRPCONFIG.Domain.TripAdvisorTrackingPixelEnabled && TRPCONFIG.Domain.TripAdvisorPartnerId !== '') {
                const taid = cookieService.get('tripadvisor_referral');
                if (taid && taid.length === 24) {
                    basketData.tripAdvisor = {
                        totalCost,
                        bookingRefs,
                        taid
                    };
                    loaderService.loadJS($window.document, 'script', 'tripAdvisor', '//static.tacdn.com/js3/taevents-c.js',
                        false, onScriptLoaded);
                }
            }

            if (_tagManagerEnabled()) {
                return _pushGABasket(tripId, baskets, totalCost);
            }

            return $q.when();
        }

        function onScriptLoaded() {
            switch (this.id) {
                case 'tripAdvisor':
                    _pushTripAdvisorBasket(basketData.tripAdvisor);
                    break;
            }
        }

        function _pushTripAdvisorBasket(data) {
            if (!data.totalCost || !data.bookingRefs || !data.taid) {
                return false;
            }
            const bookingReferences = (data.bookingRefs || []).join('|');
            const _taq = window.taq;

            const track = {
                partner: TRPCONFIG.Domain.TripAdvisorPartnerId,
                refid: data.taid,
                gbv: parseFloat(data.totalCost) * 100,
                bbv: parseFloat(data.totalCost) * 100,
                currency: TRPCONFIG.Domain.CurrencyCode,
                currency_format: 0, // eslint-disable-line
                order_id: bookingReferences, // eslint-disable-line
                is_app: TRPCONFIG.Domain.DeviceType === 'Desktop' ? 0 : 1 // eslint-disable-line
            };

            _taq('init', TRPCONFIG.Domain.TripAdvisorPixelId);
            _taq('track', 'BOOKING_CONFIRMATION', track);

            _clearCookie('tripadvisor_referral');
        }

        function _clearCookie(key) {
            const h = window.location.hostname;
            const cookieDomain = h.slice(h.indexOf('.'));

            cookieService.set(key, '', (new Date()).toUTCString(), cookieDomain);
        }

        function _pushGABasket(tripId, baskets, totalCost) {
            return addTransaction(tripId, `${totalCost}`, `${0}`).then(transaction => {
                const basketInfo = _.map(_.omit(baskets, 'all'), b => {
                    const entries = _.flatten([b]); // Normalise single entries and arrays

                    for (let i = 0, len = entries.length; i < len; i++) {
                        const basket = entries[i];

                        if (basket == null) {
                            return $q.when(null);
                        }
                        const product = productType[basket.ProductType];
                        const info = product != null ? product(transaction.transactionId, basket, baskets.f) : null;

                        if (info == null) {
                            return $q.when(null);
                        }

                        return info
                            .then(result => result)
                            .catch(() => null);
                    }
                });

                return $q.all(basketInfo).then(basketResult => {
                    const output = _.reduce(basketResult, (memo, elem) => {
                        if (elem) {
                            return memo.concat(elem);
                        }
                        return memo;
                    }, []);

                    return tripService.getCurrency(tripId).then(currency => {
                        _.forEach(output, item => {
                            const { CountryCode, Language } =
                                TRPCONFIG.SelectedRegionalContext ? TRPCONFIG.SelectedRegionalContext : { CountryCode: null, Language: null };
                            const newItem = addItem(item.id, `${item.name}`, `${item.sku}`, `${item.category}`, `${item.price}`, `${item.quantity}`, `${currency}`, CountryCode, Language);
                            transaction.transactionProducts.push(newItem);
                        });

                        if (!TRPCONFIG.Domain2.NewTransactionTracking) {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push(transaction);
                        }

                        // Create rollup transaction
                        let transactionRollup = JSON.parse(JSON.stringify(transaction));
                        transactionRollup.event = 'pushTransactionRollup';

                        if (transaction.transactionCurrency !== 'AED' && TRPCONFIG.Domain.EnableAnalyticsCurrencyConversion === true) {
                            updateTransactionAed(transactionRollup);
                        } else if (!TRPCONFIG.Domain2.NewTransactionTracking) {
                            window.dataLayer.push(transactionRollup);
                        }
                    });
                });
            });
        }

        function updateTransactionAed(t) {
            getExchangeRate(t.transactionCurrency, 'AED').then(rate => {
                t.transactionTotal = calCurrency(t.transactionTotal, rate);
                t.transactionCurrency = 'AED';
                for (let i = 0; i < t.transactionProducts.length; i++) {
                    t.transactionProducts[i].currency = 'AED';
                    t.transactionProducts[i].price = calCurrency(t.transactionProducts[i].price, rate);
                }
                window.dataLayer.push(t);
            });
        }

        function calCurrency(val, rate) {
            const x = parseInt(val);
            const convertedTotal = x * rate.data;
            return convertedTotal.toFixed(2);
        }

        function getExchangeRate(from, to) {
            return $http.get(`/api2/fxrates/get?request.currencyFrom=${from}&request.currencyTo=${to}&request.futureMonth=0`);
        }

        function addTransaction(transactionId, transactionTotal, transactionTax, transactionAffiliation) {
            transactionAffiliation = transactionAffiliation || TRPCONFIG.Domain.DomainId;
            return tripService.getCurrency(transactionId).then(transactionCurrency => {
                const transaction = {
                    event: 'pushTransaction',
                    transactionId,
                    transactionAffiliation,
                    transactionTotal,
                    transactionTax,
                    transactionCurrency,
                    transactionProducts: []
                };

                return transaction;
            });
        }

        function addItem(id, name, sku, category, price, quantity, currency, dimension1, dimension2) {
            const item = {
                id,
                name,
                sku,
                category,
                price,
                quantity,
                currency,
                dimension1,
                dimension2
            };

            return item;
        }

        const service = {
            addTransaction,
            addItem,
            pushBasket
        };

        function _tagManagerEnabled() {
            return !!TRPCONFIG.Domain.GoogleTagManagerEnabled;
        }

        const noop = function() { return $q.when(); };

        if (!_tagManagerEnabled()) {
            for (const func in service) {
                service[func] = noop;
            }
        }

        return service;
    }
})();
